import { useState } from 'react';
import { DispatchAreaOption } from '@mark43/cad-api';
import { storageHelpers } from '../common/helpers/browser-storage';

const LOCATION_BIAS_LOCAL_STORAGE_KEY = 'locationBias';

export function useLocationBiasStorage() {
    const [locationBias, setLocationBiasState] = useState<DispatchAreaOption | undefined | null>(
        () => storageHelpers.getItem(LOCATION_BIAS_LOCAL_STORAGE_KEY) as DispatchAreaOption
    );

    const setLocationBias = (newDAreaValue?: DispatchAreaOption) => {
        const value = newDAreaValue ?? null;
        setLocationBiasState(value);
        storageHelpers.setItem(LOCATION_BIAS_LOCAL_STORAGE_KEY, value);
    };

    return [locationBias, setLocationBias] as const;
}
